<template>
    <div class="track_visa_container">
        <div class="account_row">
          <div class="account_title">
         Track your Visa Process
          </div>
      </div>
        
    <form class="visa_track_form_box">
        <div class="form_content">
       
        <div class="form-group">
          <label>Enter Student Code</label>
          <input v-validate="'required'" type="text" class="form-control" name="code" v-model=formData.code required>
          <span>{{ errors.first('code') }}</span>
        </div>
        <div class="form-group">
          <label for="start">Date of Birth</label>
          <input v-validate="'required'" type="date" id="start" class="form-control" name="dob" v-model=formData.dob required>
          <span>{{ errors.first('dob') }}</span>
        </div>  
        <div class="btn_container">
          <button  @click.prevent=VisaTrack class="btn_submit">VIEW STATUS</button>
        </div> 
        <div class="visa_note">
            <v-icon class="icon_size">error</v-icon>To track your visa processing get your student code from the respective consultancy.
        </div>      
        </div>  
    </form>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  data(){
    return{
     formData: {}
    }
  },
  computed: {
    ...mapGetters(['visa'])
  },
  methods: {
    VisaTrack(){
      this.$validator.validate().then(async result =>{
        if(result){
          await this.$store.dispatch('trackVisa', this.formData)
          this.$router.push('/visadetail')
        }
      });
    }
  },
   mounted(){
    document.title = 'Track Visa - Consultancy Finder';
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/TrackVisa.vue